import { useContext, useMemo } from 'react';
import { NavigationRouteContext } from '@react-navigation/native';
import type {
  GoodsDetailExtras,
  GoodsRouteParams,
} from '../../../hooks/useGoodsRoute';

const safeParse = (value: string): GoodsDetailExtras | undefined => {
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
};

export const useSameMarketRecommendOnly = (): boolean => {
  // route 가 없으면 throw 하는 useRoute 대신 context 를 직접 읽어, 주입(찜탭 등) 케이스를 허용.
  const route = useContext(NavigationRouteContext);

  return useMemo(() => {
    const params = route?.params as GoodsRouteParams['GoodsDetail'] | undefined;
    // moveToGoods push 경로는 extras 를 JSON 문자열로 싣는다 (useGoodsFrom 과 동일 처리).
    const extras =
      typeof params?.extras === 'string'
        ? safeParse(params.extras)
        : params?.extras;
    return extras?.same_market_recommend_only ?? false;
  }, [route]);
};
